export const ONE_DAY_IN_MILLISECONDS = 86400000;
export const THREE_MINUTES_IN_MILLISECONDS = 180000;
